import { browserFastApiClient } from "@/core/fastapi";
import {
  getPublicFeedbackFormApiService,
  type GetPublicFeedbackFormResult,
} from "@/generated/fastapi";

export async function getPublicFeedbackForm(
  token: string,
): Promise<GetPublicFeedbackFormResult> {
  const response = await getPublicFeedbackFormApiService({
    client: browserFastApiClient,
    path: { token },
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to load feedback form (${response.status})`);
  }

  return response.data;
}
